export default __webpack_public_path__ + "static/media/whiteboard.ce5ce27e.svg";